import React, { FC, ChangeEvent } from "react";
import { CgSearch } from "react-icons/cg";

interface SearchBoxProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const SearchBox: FC<SearchBoxProps> = ({
  placeholder = "Search",
  value,
  onChange,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="SearchBox flex gap-1 items-center bg-white w-fit py-1 border px-2 rounded-md shadow-md">
      <CgSearch className="text-xl text-gray-500 mt-1" />
      <input
        type="text"
        className="outline-none font-medium bg-transparent px-2 py-1 text-sm"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchBox;
